import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as globals from './globals';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';
import { NotificationCustomerService } from '@customers/services/notification.customer.service';
import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging';
@Injectable()
export class MessagingService {
  messaging = isSupported() ? getMessaging() : null;
  currentMessage = new BehaviorSubject(null);
  notification;
  private imprintValue = localStorage.getItem('imprintValue');
  private toastMessage = '';
  private toastType = 'info';
  constructor(
    private httpClient: HttpClient,
    private gtn: globals.GetTokenNow,
    private toastr: ToastrService,
    private ns: NotificationCustomerService
  ) {}

  checkCompatibility() {
    return isSupported();
  }

  private updateToken(token) {
    const body = {
      pushNotificationToken: token,
      pushNotificationType: 'fcm',
      deviceId: this.imprintValue
    };
    this.httpClient.post(`${globals.domain}customer/set-push-notification-token/`, JSON.stringify(body), this.gtn.getHeaders()).subscribe(
      (res:any) => {},
      err => {
        console.log(err, 'fcm');
      }
    );
  }

  getPermission() {
    if (!this.checkCompatibility()) {
      return console.log('Notification API not available in this browser.');
    }
    Notification
      .requestPermission()
      .then(() => {
        if (this.messaging) {
          return getToken(this.messaging);
        } else {
          throw new Error('Messaginng object was not found');
        }
      })
      .then(token => {
        this.updateToken(token);
      })
      .catch(err => {
        console.log('fcm', err);
      });
  }

  receiveMessage() {
    if (!this.checkCompatibility()) {
      return console.log('Notification API not available in this browser.');
    }
    onMessage(this.messaging, payload => {
      this.currentMessage.next(payload);
      this.notification = payload;
      localStorage.removeItem('notification');
      localStorage.setItem('notification', this.notification.notification.title);
      if (this.notification) {
        this.ns.updateNotification(this.notification);
        return;
      }
      this.toastMessage = this.notification.notification.title;
      this.toastType = 'info';
      this.toastr[this.toastType](this.toastMessage);
    });
  }
  onTokenRefresh() {
    getToken(this.messaging)
      .then(refreshedToken => {
        console.log('Token refreshed.', 'fcm');
        this.updateToken(refreshedToken);
      })
      .catch(function(err) {});
  }
}